import { useContext, Context } from "react"
import OptimizeExperiments from "connected-components/optimize-experiments"
import type { ModelMetadata, OptimizeExperimentsContext } from "connected-components/optimize-experiments/types"
import { InstrumentsMetadata } from "connected-components/dashboard/context/types"

import "./styles.scss"

interface OptimizeExperimentsPanelProps {
  context: Context<OptimizeExperimentsContext>
  modelMetadata: ModelMetadata
  instrumentsWithMetadata: InstrumentsMetadata
  isOptimizedExperimentsEnabled: boolean
}

export default function OptimizeExperimentsPanel({
  context,
  modelMetadata,
  instrumentsWithMetadata,
  isOptimizedExperimentsEnabled,
}: OptimizeExperimentsPanelProps) {
  const { isOptimizedExperimentsDrawerOpen } = useContext(context)

  if (!isOptimizedExperimentsEnabled) {
    return null
  }

  return (
    <div className={`optimizer-widget-panel ${isOptimizedExperimentsDrawerOpen ? "visible" : ""}`}>
      <OptimizeExperiments
        context={context}
        modelMetadata={modelMetadata}
        instrumentsWithMetadata={instrumentsWithMetadata}
      />
    </div>
  )
}
